import React from "react";
import { Toast } from "react-bootstrap";
import { ToasterView } from "../../../models/views/profile/ToasterView";
import NotifyContext from "../../../contexts/NotifyContext";

export default class NotifyToast extends React.PureComponent<{}, { show: boolean; viewDetails: ToasterView }> {
  static contextType = NotifyContext;

  constructor(props: any) {
    super(props);
    this.state = {
      viewDetails: {
        badge: "success",
        description: "",
        title: "",
      },
      show: false,
    };
  }

  componentDidMount() {
    this.context.showNotify = this.showNotify;
  }

  componentDidUpdate() {   
    this.context.showNotify = this.showNotify;
  }

  showNotify = (toasterView?: ToasterView) => {
    if (!this.state.show) {
      this.setState({
        show: true,
        viewDetails: {
          badge: toasterView?.badge ?? "success",
          description: toasterView?.description,
          title: toasterView?.title,
        },
      });
    }
  };

  close = () => {
    this.setState({
      show: false,
    });
  };

  render(): React.ReactNode {
    let { viewDetails, show } = this.state;

    return (
      <div className="toast-area" onClick={this.close}>
        <Toast
          className="d-inline-block m-1"
          onClose={this.close}
          bg={viewDetails.badge}
          show={show}
          autohide
          delay={5000}
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">
              {viewDetails.title === null ? "موفق" : viewDetails.title}
            </strong>
          </Toast.Header>
          <Toast.Body>
            {viewDetails.description === null
              ? "با موفقت انجام شد"
              : viewDetails.description}
          </Toast.Body>
        </Toast>
      </div>
    );
  }
}
